import { render, staticRenderFns } from "./fishing-wellbore-obstruction.vue?vue&type=template&id=7575fe92&scoped=true"
import script from "./fishing-wellbore-obstruction.vue?vue&type=script&lang=js"
export * from "./fishing-wellbore-obstruction.vue?vue&type=script&lang=js"
import style0 from "./fishing-wellbore-obstruction.vue?vue&type=style&index=0&id=7575fe92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7575fe92",
  null
  
)

export default component.exports